import { createAsyncThunk } from "@reduxjs/toolkit";
import {GENERATE_OTP, GET_LOGIN_METHOD, LOGIN_USER, LOGOUT, SIGNUP_USER, VALIDATE_OTP} from "./userManagement.type";
import { SignUpFormModel } from "../models/SignUpFormModel";
import loginService from "../services/userManagement.service";
import {GenerateOtpModel, ValidateOtpModel} from "../models";

export const createUser = createAsyncThunk(
    SIGNUP_USER,
    async (UserModel : SignUpFormModel) =>{
        const response = await loginService.SignUp(UserModel);
        return response.data;
    }
)

export const generateOTp = createAsyncThunk(
    GENERATE_OTP,
    async (model:GenerateOtpModel)=>{
        const response = await loginService.generateOtp(model);
        return response.data
    }
)
export const validateOTp = createAsyncThunk(
    VALIDATE_OTP,
    async (model:ValidateOtpModel)=>{
        const response = await loginService.validateOtp(model);
        return response.data
    }
)

export const logOut = createAsyncThunk(
    LOGOUT,
    async ()=>{
        const response = await loginService.LogOut();
        return response.data
    }
)
export const getLoginMethod = createAsyncThunk(
    GET_LOGIN_METHOD,
    async ()=>{
        const response = await loginService.getLoginMethod();
        return response.data
    }
)
